




import {Vue, Component} from 'vue-property-decorator'

import PaymentsDetail  from '@/components/PaymentsDetail.vue'

@Component({
  components: {
      PaymentsDetail
  }
})
export default class PaymentsDetailView extends Vue {
}
